// extracted by mini-css-extract-plugin
export default {"container":"SelectChat_container__d2t7V","barContainer":"SelectChat_barContainer__d091M"};